import React from "react";
import { Modal, Form, Input, Button, notification } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createDrawingFolder } from "../services/drawingFoldersAPI";
import { useAuth } from "../hooks/useAuth";

const CreateDrawingFolderModal = ({ visible, onClose, parentId = null }) => {
  const { selectedProject } = useAuth();
  const projectId = selectedProject?.project_id;
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const mutation = useMutation({
    mutationFn: (data) =>
      createDrawingFolder(projectId, {
        ...data,
        parent_id: parentId || null,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(["drawingFolders", projectId]);
      onClose();
      form.resetFields();
      notification.success({ message: "Drawing folder created successfully" });
    },
    onError: (error) => {
      notification.error({
        message: "Failed to create drawing folder",
        description: error.message,
      });
    },
  });

  const handleCreateFolder = (values) => {
    mutation.mutate(values);
  };

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Create Drawing Folder"
      open={visible}
      onCancel={handleClose}
      footer={null}
    >
      <Form form={form} onFinish={handleCreateFolder} layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input the folder name!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={mutation.isPending}
            style={{ width: "100%" }}
          >
            Create Folder
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateDrawingFolderModal;
